import { Linkedin, Mail, Phone } from "lucide-react";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Who We Serve", href: "#who-we-serve" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#consult" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy border-t border-white/10 pt-16 pb-8">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <p className="font-display text-2xl font-extrabold tracking-tight text-white">
            Cogniti<span className="text-brand">.ai</span> CFO, LLP
          </p>
          <p className="mt-3 text-sm font-semibold uppercase tracking-[0.2em] text-white/50">
            AI-Enabled Virtual & Fractional CFO Services
          </p>
          <p className="mt-4 text-sm font-bold tracking-wide text-brand">
            Fractional CFO <span className="text-white/30">|</span> Finance Shared Services <span className="text-white/30">|</span> Controllership <span className="text-white/30">|</span> FP&amp;A <span className="text-white/30">|</span> Finance Transformation
          </p>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/55">
            Enterprise-grade finance leadership, AI-enabled and right-sized for
            high-growth companies, GCCs and global businesses building in India.
          </p>
        </div>

        <nav data-testid="footer-nav" aria-label="Footer">
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-white/40">Navigate</p>
          <ul className="mt-5 space-y-3">
            {NAV.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  data-testid={`footer-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm font-semibold text-white/70 transition-colors duration-200 hover:text-brand"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-white/40">Contact</p>
          <p className="mt-5 font-display text-lg font-bold text-white">Ramesh Nanduri</p>
          <p className="text-sm text-white/55">Founder & Managing Partner</p>
          <div className="mt-5 space-y-3">
            <a
              data-testid="footer-email-link"
              href="mailto:ramesh@cogniticfo.com"
              className="flex items-center gap-3 text-sm font-semibold text-white/70 transition-colors duration-200 hover:text-brand"
            >
              <Mail size={15} className="text-brand" />
              ramesh@cogniticfo.com
            </a>
            <a
              data-testid="footer-phone-link"
              href="tel:+919704456206"
              className="flex items-center gap-3 text-sm font-semibold text-white/70 transition-colors duration-200 hover:text-brand"
            >
              <Phone size={15} className="text-brand" />
              +91 970 445 6206
            </a>
            <a
              data-testid="footer-linkedin-link"
              href="https://www.linkedin.com/in/rananduri"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white/70 transition-[border-color,color] duration-200 hover:border-brand hover:text-brand"
            >
              <Linkedin size={15} />
            </a>
          </div>
        </div>
      </div>

      <div className="mt-14 flex flex-col md:flex-row items-center justify-between gap-4 border-t border-white/10 pt-7">
        <p className="text-xs text-white/45">© 2026 Cogniti.ai CFO, LLP. All rights reserved.</p>
        <div className="flex items-center gap-6">
          <a
            href="/privacy-policy"
            data-testid="footer-privacy-link"
            className="text-xs text-white/45 transition-colors duration-200 hover:text-brand"
          >
            Privacy Policy
          </a>
          <a
            href="/terms-of-service"
            data-testid="footer-terms-link"
            className="text-xs text-white/45 transition-colors duration-200 hover:text-brand"
          >
            Terms of Service
          </a>
        </div>
      </div>
    </div>
  </footer>
);
